import UmedsSuccessIcon from '@/components/common/UmedsSuccessIcon';
import { Box, Typography } from '@montugroup/design-system';
import { styled } from '@mui/material/styles';
import React from 'react';

interface OrderSuccessProps {
  orderId: string;
  email?: string;
  status: 'success' | 'pending';
}

const SuccessContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(6),
}));

const IconWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: theme.spacing(2.5),
}));

const HeaderSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(4),
}));

const HeaderContent = styled(Box)`
  display: flex;
  flex-direction: column;
`;

const OrderDetails = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: theme.spacing(2),
  alignSelf: 'stretch',
}));

const statusContent = {
  success: {
    title: 'Thank you!',
    subtitle: 'Your order has been placed.',
  },
  pending: {
    title: 'Almost there!',
    subtitle: 'Your order is pending approval letter.',
  },
};

export const OrderSuccess: React.FC<OrderSuccessProps> = ({ orderId, email, status = 'success' }) => {
  const content = statusContent[status];

  return (
    <SuccessContainer>
      <HeaderSection>
        <IconWrapper>
          <UmedsSuccessIcon />
        </IconWrapper>
        <HeaderContent>
          <Typography sx={(theme) => ({ color: theme.palette.primary.main })} variant="h5">
            {content.title}
          </Typography>
          <Typography variant="body2" sx={(theme) => ({ color: theme.palette.text.secondary })}>
            {content.subtitle}
          </Typography>
        </HeaderContent>
      </HeaderSection>

      <OrderDetails>
        <Typography variant="body2">
          Order:{' '}
          <Typography component="span" variant="body2" fontWeight="600">
            {orderId}
          </Typography>
        </Typography>
        {status === 'success' && email && (
          <Typography variant="body2">
            We&#39;ve sent an email to{' '}
            <Typography component="span" variant="body2" fontWeight="600">
              {email}
            </Typography>{' '}
            with your order confirmation and invoice.
          </Typography>
        )}
      </OrderDetails>
    </SuccessContainer>
  );
};
